export default {"src":"https://fishbrain.com/_next/static/media/headerWaveMobile.6fe8fe8a.svg","height":311,"width":375,"blurWidth":0,"blurHeight":0};